import Column from '@components/Column';
import styled from '@emotion/styled';
import { HTMLAttributes, ReactNode } from 'react';

interface Props {
    children?: ReactNode;
}
function Card(props:HTMLAttributes<HTMLDivElement>) {
    return (
        <Base fullWidth {...props}/>
    );
}

const Base = styled(Column)`
    background-color: var(--color-white);
    border: 1px solid var(--color-gray3);
    border-radius: 8px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);
    overflow: hidden;
`;

const BodyBase = styled(Column)`
    padding: 16px 12px;
    overflow: hidden;
`;

Card.Body = function Body(props:Props) {
    return (<BodyBase spacing={12} fullWidth {...props} />);
};

const FooterBase = styled(Column)`
    border-top: 1px solid var(--color-gray3);
    padding: 8px 12px;
`;

Card.Footer = function Footer(props:Props) {
    return (
        <FooterBase align='center' justify='center' fullWidth {...props}/>
    );
};
export default Card;
